import React, {useState, useEffect } from 'react';
import './App.css';
import WOW from 'wowjs';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation
} from "react-router-dom";
import {ScrollToTop} from './Utils/Utils';
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { GET, LOGIN, HandleError, GetError } from "./Services/Net/Request/NetService";
import DashboardPage from './Pages/DashboardPage';
import LoginPage from './Pages/LoginPage';
import cookie from 'react-cookies';
import {GetHospital} from './Utils/Utils';
import FromPage from './Pages/FromPage';
import NotFound from './Pages/NotFound';

function App() {
  return (
    <Router>
      <ScrollToTop/>
      <Main/>
    </Router>
  );
}

function Main()
{
  let location = useLocation();
  const [remember, setRemember] = useState(cookie.load('hrsj_dir_defaultuser')!==undefined);
  const [logstatus, setLogstatus] = useState("");
  const [user, setUser] = useState(cookie.load('hrsj_dir_userdata'));
  const [hospital, setHospital] = useState(GetHospital());

  useEffect(() => {
    const abortController = new AbortController();

    new WOW.WOW({
        live: false
    }).init();

    if (user)
    {
      GET("login/echoping",abortController.signal).then(
        (response) =>{
          if (!abortController.signal.aborted)
          {
            if (response.status !== 200) 
            {
              cookie.remove("hrsj_dir_userdata");
              setUser(undefined);
            }
          }
        }).catch(function(error) { 
          if (!abortController.signal.aborted)
          {
            cookie.remove("hrsj_dir_userdata");
            setUser(undefined);
          }
        });
    }

    return () => {
      abortController.abort();
    };
  },[user, setUser]);

  function Login(name,pass)
  {
    setLogstatus("?");
    LOGIN(name,pass).then(
      (response) =>{
        if (response.ok)
        {
          response.json().then(function(data) {
            setLogstatus("");
            cookie.save("hrsj_dir_userdata",data);
            if(remember)
              cookie.save("hrsj_dir_defaultuser",name,
              {
                expires: new Date(2999,1,1,0,0,0),
              });
              else
              cookie.remove("hrsj_dir_defaultuser");
            setUser(data);
          });
        } else {
          console.log(response);
          HandleError(response).then((error) => {
            setLogstatus(GetError(error));
          });
        }
      }
    ).catch(function(error) { setLogstatus("Error de conexión: "+error); });
  }

  function LogOut()
  {
    cookie.remove("hrsj_dir_userdata");
    setUser(undefined);
  }

  function ChangeHospital(val)
  {
    setHospital(val);
    cookie.save("hrsj_dir_hospital",val);
  }

  function SwitchHosp()
  {
    const newhospital = hospital === 'LC' ? 'VR' : 'LC';
    setHospital(newhospital);
    cookie.save("hrsj_dir_hospital",newhospital);
  }

  return (
    <main className="App" id="main">
      <TransitionGroup id='TransitionGrup'>
        <CSSTransition
        key={location.key}
        classNames="fade"
        timeout={300}>
          <Switch location={location}>
            <Route path="/from/:userdata">
              <FromPage setuser={(u) => setUser(u)} 
                        sethospital={(h) => ChangeHospital(h)}/>
            </Route>
            <Route path="/login">
              <LoginPage user={user} 
                      hospital={hospital} 
                      status={logstatus} 
                      remember={remember}
                      onSubmit={(u,p) => Login(u,p)}
                      ChangeHosp={(v) => ChangeHospital(v)}
                      setRemember={(v) => setRemember(v)}
                      />
            </Route>
            <Route path="/dashboard">
              <DashboardPage user={user}  hospital={hospital}
                      LogOut={() => LogOut()}
                      SwitchHosp={() => SwitchHosp()}/>
            </Route>
            <Route path="*">
              <NotFound user={user} />
            </Route>
          </Switch>
        </CSSTransition>
      </TransitionGroup>
    </main>
  )
}

export default App;
